<!-- eslint-disable -->
<template>
  <header class="mb-5">
    <div class="header-top">
      <div class="container">
        <div class="logo">
          <a href="#"><img src="/images/logo/logoBPP.png?ver=0.1.6" alt="Logo" srcset=""></a>
        </div>
        <div class="header-top-right">
          <a class="nav-link text-gray-600" @click="logout">
                <i class="bi bi-door-open-fill bi-sub fs-4 text-gray-600"></i> Log Out
              </a>
        </div>
      </div>
    </div>
  </header>
</template>
<!-- eslint-disable -->
<script>
export default {
  name: "PrimaryTopBar",
  data() {
    return {
      biodata: JSON.parse(localStorage.getItem('setusers'))
    };
  },
  methods: {
    async logout() {
      await this.$store.dispatch("LogOut");
      this.$router.push("/");
    },
  }
}
</script>